import { parseTime } from '@/utils'
export const STAGING_CONSTANT = {
  inStageStock: [
    { title: 'Tag Id', dataIndex: 'tagId', minWidth: 100 },
    { title: 'Job Id', dataIndex: 'jobId', minWidth: 100 },
    { title: 'Sub Job Id', dataIndex: 'subJobId', width: 200 },
    { title: 'FG Name', dataIndex: 'fgName', minWidth: 100 },
    {
      title: 'Stage-In Time',
      dataIndex: 'stInTime',
      minWidth: 100,
      sorter: (a, b) => a.stInTime - b.stInTime,
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
    { title: 'Country', dataIndex: 'country', minWidth: 100 },
  ],
  fifoViolation: [
    { title: 'Tag Id', dataIndex: 'tagId', minWidth: 100 },
    { title: 'Object Id', dataIndex: 'objectId', minWidth: 100 },
    { title: 'Job Id', dataIndex: 'jobId', minWidth: 100 },
    { title: 'Jump Sequence', dataIndex: 'jumpSeq', minWidth: 100 },
    {
      title: 'Created On',
      dataIndex: 'createOn',
      minWidth: 100,
      sorter: (a, b) => a.createOn - b.createOn,
      defaultSortOrder: 'descend',
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
  ],
  alertStop: [
    {
      title: 'Created On',
      dataIndex: 'createOn',
      minWidth: 100,
      sorter: (a, b) => a.createOn - b.createOn,
      defaultSortOrder: 'descend',
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
    { title: 'Andon Description', dataIndex: 'description', minWidth: 200 },
    { title: 'Stop Ws', dataIndex: 'stopWS', minWidth: 100 },
    { title: 'Status', dataIndex: 'status', minWidth: 100 },
  ],
  waitingTime: [
    { title: 'Object Id', dataIndex: 'objectId', minWidth: 100 },
    { title: 'Job Id', dataIndex: 'jobId', minWidth: 100 },
    {
      title: 'St-In Time',
      dataIndex: 'stInTime',
      minWidth: 100,
      sorter: (a, b) => a.stInTime - b.stInTime,
      defaultSortOrder: 'descend',
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
    {
      title: 'St-Out Time',
      dataIndex: 'stOutTime',
      minWidth: 100,
      sorter: (a, b) => a.stOutTime - b.stOutTime,
      defaultSortOrder: 'descend',
      customRender({ text }) {
        return parseTime(text, '{y}/{m}/{d} {h}:{i}')
      },
    },
  ],
}
export const colsData = [
  {
    name: 'In-Stage Stock',
    dataIndex: '',
    field: 'inStageStock',
  },
  {
    name: 'FIFO Violation',
    dataIndex: '',
    field: 'fifoViolation',
  },
  {
    name: 'Stop/Alert',
    dataIndex: '',
    field: 'alertStop',
  },
  {
    name: 'Avg.Waiting Time',
    dataIndex: '',
    field: 'waitingTime',
    unit: 'Min',
  },
]

export default STAGING_CONSTANT
